import { useState } from 'react';

export const useMenuOpen = (defaultState = false) => {
  const [isOpen, setIsOpen] = useState(defaultState);
  const toggle = () => setIsOpen(!isOpen);

  return { isOpen, setIsOpen, toggle };
};
